import React, { useState } from 'react';
import { FaSearch } from 'react-icons/fa';

const faqData = [
  {
    question: "Como funciona o pagamento?",
    answer: "A reserva é confirmada mediante o pagamento de 40% do valor total. O restante do valor deve ser quitado até o momento da entrada no chalé."
  },
  {
    question: "Aceitam animais de estimação?",
    answer: "Devido ao risco de fuga na região de mata e para preservar a fauna local, infelizmente não aceitamos pets."
  },
  {
    question: "Quais são os horários de check-in e check-out?",
    answer: "O check-in é realizado a partir das 14h e o check-out deve ser feito até as 13h, permitindo que você aproveite o dia todo."
  },
  {
    question: "Qual o mínimo de diárias?",
    answer: "Trabalhamos com um mínimo de duas diárias para garantir que você tenha tempo suficiente para relaxar e aproveitar a experiência completa."
  },
  {
    question: "Qual a política de cancelamento?",
    answer: "Cancelamentos podem ser feitos com reembolso total até 14 dias antes da data do check-in."
  },
  {
    question: "A cabana de vidro é segura e privativa?",
    answer: "Sim! A cabana conta com cortinas blackout em todos os vidros para garantir total privacidade e conforto."
  }
];

const Faq = () => {
  const [searchTerm, setSearchTerm] = useState('');

  const filteredFaq = faqData.filter(item =>
    item.question.toLowerCase().includes(searchTerm.toLowerCase()) ||
    item.answer.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const scrollToBooking = () => {
    const bookingSection = document.querySelector('.booking-widget');
    if (bookingSection) {
      bookingSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="faq-section" id="faq">
      <h2>Dúvidas Frequentes</h2>

      <div className="faq-search-container">
        <div className="search-input-wrapper">
          <FaSearch className="search-icon" />
          <input
            type="text"
            placeholder="Buscar dúvida..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="faq-search-input"
          />
        </div>
      </div>

      <div className="faq-grid">
        {filteredFaq.length > 0 ? (
          filteredFaq.map((item, index) => (
            <div className="faq-item glass-panel" key={index}>
              <h3>{item.question}</h3>
              <p>{item.answer}</p>
            </div>
          ))
        ) : (
          <p className="no-results">Nenhuma dúvida encontrada para "{searchTerm}".</p>
        )}
      </div>

      <div className="faq-cta-container">
        <button className="section-cta" onClick={scrollToBooking}>
          Reservar
        </button>
      </div>
    </section>
  );
};

export default Faq;
